// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Belt_Int = require("rescript/lib/js/belt_Int.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_format = require("rescript/lib/js/caml_format.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Querystringify = require("querystringify");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Pagination$ReactHooksTemplate = require("../common/Pagination.res.js");
var TextCategory$ReactHooksTemplate = require("./textCategory.res.js");
var PaginationUtils$ReactHooksTemplate = require("../common/PaginationUtils.res.js");
var TextCategoryForm$ReactHooksTemplate = require("./TextCategoryForm.res.js");

var initialState_selectedTextCategory = TextCategory$ReactHooksTemplate.empty();

var initialState = {
  loading: true,
  textCategories: /* [] */0,
  formAction: "Create",
  textCategoryModalToggle: false,
  selectedTextCategory: initialState_selectedTextCategory,
  outsideClick: true,
  llmEnabled: false
};

function reducer(state, action) {
  if (typeof action !== "object") {
    if (action === "FetchTextCategoriesInProgress") {
      return {
              loading: true,
              textCategories: state.textCategories,
              formAction: state.formAction,
              textCategoryModalToggle: state.textCategoryModalToggle,
              selectedTextCategory: state.selectedTextCategory,
              outsideClick: state.outsideClick,
              llmEnabled: state.llmEnabled
            };
    } else {
      return {
              loading: state.loading,
              textCategories: state.textCategories,
              formAction: state.formAction,
              textCategoryModalToggle: !state.textCategoryModalToggle,
              selectedTextCategory: state.selectedTextCategory,
              outsideClick: state.outsideClick,
              llmEnabled: state.llmEnabled
            };
    }
  }
  switch (action.TAG) {
    case "FetchTextCategoriesCompleted" :
        return {
                loading: false,
                textCategories: action._0,
                formAction: state.formAction,
                textCategoryModalToggle: state.textCategoryModalToggle,
                selectedTextCategory: state.selectedTextCategory,
                outsideClick: state.outsideClick,
                llmEnabled: state.llmEnabled
              };
    case "SetFormAction" :
        return {
                loading: state.loading,
                textCategories: state.textCategories,
                formAction: action._0,
                textCategoryModalToggle: state.textCategoryModalToggle,
                selectedTextCategory: state.selectedTextCategory,
                outsideClick: state.outsideClick,
                llmEnabled: state.llmEnabled
              };
    case "SetTextCategory" :
        return {
                loading: state.loading,
                textCategories: state.textCategories,
                formAction: state.formAction,
                textCategoryModalToggle: state.textCategoryModalToggle,
                selectedTextCategory: action._0,
                outsideClick: state.outsideClick,
                llmEnabled: state.llmEnabled
              };
    case "SetOutsideClick" :
        return {
                loading: state.loading,
                textCategories: state.textCategories,
                formAction: state.formAction,
                textCategoryModalToggle: state.textCategoryModalToggle,
                selectedTextCategory: state.selectedTextCategory,
                outsideClick: action._0,
                llmEnabled: state.llmEnabled
              };
    case "SetLLMEnabled" :
        return {
                loading: state.loading,
                textCategories: state.textCategories,
                formAction: state.formAction,
                textCategoryModalToggle: state.textCategoryModalToggle,
                selectedTextCategory: state.selectedTextCategory,
                outsideClick: state.outsideClick,
                llmEnabled: action._0
              };
    
  }
}

function totalRecord(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

function perPage(x) {
  if (x !== undefined) {
    return x;
  } else {
    return "1";
  }
}

var emptyPageInfo = {
  total: "1",
  per_page: "1"
};

var searchPlaceholder = "Search Categories";

function TextCategories(props) {
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        return emptyPageInfo;
      });
  var setPageInfo = match$1[1];
  var pageInfo = match$1[0];
  var match$2 = React.useState(function (param) {
        
      });
  var setSearchKey = match$2[1];
  var searchKey = match$2[0];
  var queryParams = Querystringify.parse(props.search);
  var x = Js_dict.get(queryParams, "page");
  var currentPage;
  if (x !== undefined && x !== "") {
    var x$1 = Belt_Int.fromString(x);
    currentPage = x$1 !== undefined ? x$1 : 1;
  } else {
    currentPage = 1;
  }
  var x$2 = Js_dict.get(queryParams, "search");
  var currentSearchKey = x$2 !== undefined && x$2 !== "" ? x$2 : undefined;
  var handlePageChange = function (pageNumber) {
    var pageNumber$1 = String(pageNumber);
    if (currentSearchKey !== undefined) {
      return RescriptReactRouter.push("/general_settings?page=" + pageNumber$1 + "&search=" + currentSearchKey + "#text_categories");
    } else {
      return RescriptReactRouter.push("/general_settings?page=" + pageNumber$1 + "#text_categories");
    }
  };
  var totalCount = Caml_format.int_of_string(pageInfo.total);
  var perPageCount = Caml_format.int_of_string(pageInfo.per_page);
  var totalPagesCount = PaginationUtils$ReactHooksTemplate.totalPages(totalCount, perPageCount);
  var match$3 = state.formAction;
  var disabled;
  switch (match$3) {
    case "Create" :
    case "Update" :
        disabled = false;
        break;
    case "Delete" :
        disabled = true;
        break;
    
  }
  var match$4 = state.formAction;
  var showDescription;
  switch (match$4) {
    case "Create" :
        showDescription = false;
        break;
    case "Update" :
    case "Delete" :
        showDescription = true;
        break;
    
  }
  React.useEffect((function (param) {
          var pageNumber = String(currentPage);
          var url = currentSearchKey !== undefined ? "/api/v1/text_categories?page=" + pageNumber + "&search=" + currentSearchKey : "/api/v1/text_categories?page=" + pageNumber;
          Curry._1(dispatch, "FetchTextCategoriesInProgress");
          Js_promise.then_((function (param) {
                  var json = param[1];
                  var headers = param[0];
                  var x = headers.get("Total");
                  var total = x !== null ? (
                      x === null ? undefined : Caml_option.some(x)
                    ) : "1";
                  var x$1 = headers.get("Per-Page");
                  var per_page = x$1 !== null ? (
                      x$1 === null ? undefined : Caml_option.some(x$1)
                    ) : "1";
                  Curry._1(setPageInfo, (function (param) {
                          return {
                                  total: total,
                                  per_page: per_page
                                };
                        }));
                  Curry._1(setSearchKey, (function (param) {
                          return currentSearchKey;
                        }));
                  Js_promise.then_((function (json) {
                          return Js_promise.then_((function (llmEnabled) {
                                        return Promise.resolve(Curry._1(dispatch, {
                                                        TAG: "SetLLMEnabled",
                                                        _0: llmEnabled
                                                      }));
                                      }), Promise.resolve(Json_decode.field("llm_enabled", Json_decode.bool, json)));
                        }), json);
                  return Js_promise.then_((function (json) {
                                return Js_promise.then_((function (categories) {
                                              return Promise.resolve(Curry._1(dispatch, {
                                                              TAG: "FetchTextCategoriesCompleted",
                                                              _0: categories
                                                            }));
                                            }), Promise.resolve(Json_decode.field("text_categories", (function (param) {
                                                      return Json_decode.list(TextCategory$ReactHooksTemplate.fromJson, param);
                                                    }), json)));
                              }), json);
                }), Http$ReactHooksTemplate.fetchGetJSONWithHeader(url));
        }), [
        currentPage,
        currentSearchKey
      ]);
  var onFormSubmit = function (textCategory) {
    var textCategoryId = TextCategory$ReactHooksTemplate.id(textCategory);
    var params = {};
    params["text_category"] = TextCategory$ReactHooksTemplate.encode(textCategory);
    var match = state.formAction;
    var submitPromise;
    switch (match) {
      case "Create" :
          submitPromise = Http$ReactHooksTemplate.fetchPostJSON("/api/v1/text_categories", params);
          break;
      case "Update" :
          submitPromise = Http$ReactHooksTemplate.fetchPostJSON("/api/v1/text_categories/" + String(Belt_Option.getExn(textCategoryId)) + "/update", params);
          break;
      case "Delete" :
          submitPromise = Http$ReactHooksTemplate.fetchPostJSON("/api/v1/text_categories/" + String(Belt_Option.getExn(textCategoryId)) + "/delete", {});
          break;
      
    }
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("failed", Json_decode.string, param);
                  }), response);
            if (status === "success") {
              window.location.reload();
            }
            return Promise.resolve();
          }), submitPromise);
  };
  var tmp;
  if (state.loading) {
    tmp = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    className: "w-6 h-6 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"
                                  }),
                              JsxRuntime.jsx("span", {
                                    children: "Loading Text Categories...",
                                    className: "text-gray-600"
                                  })
                            ],
                            className: "flex items-center space-x-3"
                          }),
                      className: "flex items-center justify-center py-20"
                    }),
                className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
              }),
          className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
        });
  } else {
    var tmp$1;
    tmp$1 = searchKey !== undefined && searchKey !== "" ? JsxRuntime.jsx("button", {
            children: JsxRuntime.jsx("span", {
                  children: "✕",
                  className: "text-sm"
                }),
            className: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors duration-200",
            type: "button",
            onClick: (function (param) {
                Curry._1(setSearchKey, (function (param) {
                        
                      }));
                RescriptReactRouter.push("/general_settings?page=1#text_categories");
              })
          }) : null;
    var tmp$2;
    if (state.textCategoryModalToggle) {
      var match$5 = state.formAction;
      var tmp$3;
      switch (match$5) {
        case "Create" :
            tmp$3 = "Create New Text Category";
            break;
        case "Update" :
            tmp$3 = "Update Text Category";
            break;
        case "Delete" :
            tmp$3 = "Delete Text Category";
            break;
        
      }
      tmp$2 = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsx("div", {
                          className: "fixed inset-0 transition-opacity",
                          onClick: (function (param) {
                              Curry._1(dispatch, "ToggleTextCategoryModal");
                            })
                        }),
                    JsxRuntime.jsx("span", {
                          className: "hidden sm:inline-block sm:align-middle sm:h-screen"
                        }),
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("span", {
                                                        children: "📝",
                                                        className: "text-lg"
                                                      }),
                                                  JsxRuntime.jsx("h3", {
                                                        children: tmp$3,
                                                        className: "text-lg font-bold text-gray-900"
                                                      })
                                                ],
                                                className: "flex items-center space-x-2"
                                              }),
                                          JsxRuntime.jsx("button", {
                                                children: JsxRuntime.jsx("img", {
                                                      className: "h-4 w-4",
                                                      src: Image$ReactHooksTemplate.closeIcon
                                                    }),
                                                className: "text-gray-400 hover:text-gray-600 transition-colors duration-200",
                                                onClick: (function (param) {
                                                    Curry._1(dispatch, "ToggleTextCategoryModal");
                                                  })
                                              })
                                        ],
                                        className: "flex items-center justify-between"
                                      }),
                                  className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-4 border-b border-gray-200"
                                }),
                            JsxRuntime.jsx(TextCategoryForm$ReactHooksTemplate.make, {
                                  showDescription: showDescription,
                                  llmEnabled: state.llmEnabled,
                                  selectedTextCategory: state.selectedTextCategory,
                                  onFormSubmit: onFormSubmit,
                                  toggleModal: (function (param) {
                                      Curry._1(dispatch, "ToggleTextCategoryModal");
                                    }),
                                  disabled: disabled
                                })
                          ],
                          className: "inline-block align-bottom bg-white rounded-2xl shadow-2xl border border-gray-100 transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full overflow-hidden"
                        })
                  ],
                  className: "flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
                }),
            className: "fixed inset-0 z-50 overflow-y-auto",
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.6)"
            }
          });
    } else {
      tmp$2 = null;
    }
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
                  children: JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("span", {
                                                  children: "📝",
                                                  className: "text-xl"
                                                }),
                                            className: "flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-blue-100 to-indigo-100 shadow-sm"
                                          }),
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsx("h1", {
                                                    children: "Text Categories",
                                                    className: "text-2xl font-bold text-gray-900"
                                                  }),
                                              JsxRuntime.jsx("p", {
                                                    children: "Organize and classify text responses with custom categories",
                                                    className: "text-sm text-gray-600 mt-1"
                                                  })
                                            ]
                                          })
                                    ],
                                    className: "flex items-center space-x-3"
                                  }),
                              className: "flex items-center justify-between"
                            }),
                        className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-6 border-b border-gray-200"
                      }),
                  className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden mb-6 hover:shadow-xl transition-shadow duration-300"
                }),
            JsxRuntime.jsxs("div", {
                  children: [
                    JsxRuntime.jsxs("div", {
                          children: [
                            JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("span", {
                                                  children: "📋",
                                                  className: "text-lg"
                                                }),
                                            JsxRuntime.jsx("h2", {
                                                  children: "Category List",
                                                  className: "text-lg font-bold text-gray-900"
                                                }),
                                            JsxRuntime.jsx("span", {
                                                  children: String(List.length(state.textCategories)) + " categories",
                                                  className: "inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded-full"
                                                })
                                          ],
                                          className: "flex items-center space-x-2"
                                        }),
                                    JsxRuntime.jsxs("button", {
                                          children: [
                                            JsxRuntime.jsx("span", {
                                                  children: "+",
                                                  className: "mr-2"
                                                }),
                                            "Create New Category"
                                          ],
                                          className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                          onClick: (function (param) {
                                              Curry._1(dispatch, {
                                                    TAG: "SetFormAction",
                                                    _0: "Create"
                                                  });
                                              Curry._1(dispatch, "ToggleTextCategoryModal");
                                            })
                                        })
                                  ],
                                  className: "flex items-center justify-between"
                                }),
                            JsxRuntime.jsx("p", {
                                  children: "Classify text responses for better analysis and reporting",
                                  className: "text-sm text-gray-600 mt-1"
                                })
                          ],
                          className: "bg-gradient-to-r from-purple-50 to-pink-50 px-6 py-4 border-b border-gray-200"
                        }),
                    JsxRuntime.jsx("div", {
                          children: JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsxs("form", {
                                            children: [
                                              JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx("span", {
                                                          children: "🔍",
                                                          className: "text-gray-400"
                                                        }),
                                                    className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                                                  }),
                                              JsxRuntime.jsx("input", {
                                                    className: "w-full pl-10 pr-10 py-2.5 text-sm text-gray-900 placeholder-gray-400 bg-white border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200",
                                                    placeholder: searchPlaceholder,
                                                    type: "text",
                                                    value: Belt_Option.getWithDefault(searchKey, ""),
                                                    onChange: (function ($$event) {
                                                        var value = $$event.target.value;
                                                        Curry._1(setSearchKey, (function (param) {
                                                                if (value === "") {
                                                                  return ;
                                                                } else {
                                                                  return value;
                                                                }
                                                              }));
                                                      })
                                                  }),
                                              tmp$1
                                            ],
                                            className: "relative",
                                            onSubmit: (function ($$event) {
                                                $$event.preventDefault();
                                                if (searchKey !== undefined) {
                                                  return RescriptReactRouter.push("/general_settings?search=" + searchKey + "#text_categories");
                                                } else {
                                                  return RescriptReactRouter.push("/general_settings?page=1#text_categories");
                                                }
                                              })
                                          }),
                                      className: "flex-1 max-w-md"
                                    }),
                                className: "flex items-center justify-between gap-4"
                              }),
                          className: "px-6 py-4 bg-gray-50 border-b border-gray-200"
                        }),
                    JsxRuntime.jsx(Pagination$ReactHooksTemplate.Bar.make, {
                          currentPage: currentPage,
                          totalPages: totalPagesCount,
                          totalRecords: totalCount,
                          perPage: perPageCount,
                          handlePageChange: handlePageChange,
                          itemLabel: "categories",
                          className: "mb-4"
                        }),
                    JsxRuntime.jsx("div", {
                          children: List.length(state.textCategories) > 0 ? JsxRuntime.jsxs("table", {
                                  children: [
                                    JsxRuntime.jsx("thead", {
                                          children: JsxRuntime.jsxs("tr", {
                                                children: [
                                                  JsxRuntime.jsx("th", {
                                                        children: "Name",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      }),
                                                  JsxRuntime.jsx("th", {
                                                        children: "Description",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      }),
                                                  JsxRuntime.jsx("th", {
                                                        children: "Actions",
                                                        className: "text-left py-3 px-4 font-medium text-gray-700"
                                                      })
                                                ]
                                              }),
                                          className: "bg-gray-50 border-b border-gray-200"
                                        }),
                                    JsxRuntime.jsx("tbody", {
                                          children: $$Array.of_list(List.map((function (textCategory) {
                                                      var desc = TextCategory$ReactHooksTemplate.description(textCategory);
                                                      return JsxRuntime.jsxs("tr", {
                                                                  children: [
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsx("div", {
                                                                                children: JsxRuntime.jsx("span", {
                                                                                      children: TextCategory$ReactHooksTemplate.name(textCategory),
                                                                                      className: "text-sm font-medium text-gray-900"
                                                                                    }),
                                                                                className: "flex items-center space-x-2"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        }),
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsx("span", {
                                                                                children: desc !== undefined ? desc : JsxRuntime.jsx("span", {
                                                                                        children: "No description",
                                                                                        className: "text-gray-400 italic"
                                                                                      }),
                                                                                className: "text-sm text-gray-600"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        }),
                                                                    JsxRuntime.jsx("td", {
                                                                          children: JsxRuntime.jsxs("div", {
                                                                                children: [
                                                                                  JsxRuntime.jsx("button", {
                                                                                        children: JsxRuntime.jsx("img", {
                                                                                              className: "h-4 w-4",
                                                                                              src: Image$ReactHooksTemplate.edit
                                                                                            }),
                                                                                        className: "p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors duration-200",
                                                                                        title: "Edit category",
                                                                                        onClick: (function (param) {
                                                                                            Curry._1(dispatch, {
                                                                                                  TAG: "SetFormAction",
                                                                                                  _0: "Update"
                                                                                                });
                                                                                            Curry._1(dispatch, "ToggleTextCategoryModal");
                                                                                            Curry._1(dispatch, {
                                                                                                  TAG: "SetTextCategory",
                                                                                                  _0: textCategory
                                                                                                });
                                                                                          })
                                                                                      }),
                                                                                  JsxRuntime.jsx("button", {
                                                                                        children: JsxRuntime.jsx("img", {
                                                                                              className: "h-4 w-4",
                                                                                              src: Image$ReactHooksTemplate.trashGrey
                                                                                            }),
                                                                                        className: "p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors duration-200",
                                                                                        title: "Delete category",
                                                                                        onClick: (function (param) {
                                                                                            Curry._1(dispatch, {
                                                                                                  TAG: "SetFormAction",
                                                                                                  _0: "Delete"
                                                                                                });
                                                                                            Curry._1(dispatch, "ToggleTextCategoryModal");
                                                                                            Curry._1(dispatch, {
                                                                                                  TAG: "SetTextCategory",
                                                                                                  _0: textCategory
                                                                                                });
                                                                                          })
                                                                                      })
                                                                                ],
                                                                                className: "flex items-center space-x-2"
                                                                              }),
                                                                          className: "py-4 px-4"
                                                                        })
                                                                  ],
                                                                  className: "hover:bg-gray-50 transition-all duration-200 hover:shadow-sm"
                                                                }, String(Belt_Option.getExn(TextCategory$ReactHooksTemplate.id(textCategory))));
                                                    }), state.textCategories)),
                                          className: "divide-y divide-gray-100"
                                        })
                                  ],
                                  className: "w-full text-sm"
                                }) : JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx("span", {
                                                      children: "📝",
                                                      className: "text-2xl text-gray-400"
                                                    }),
                                                className: "w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center"
                                              }),
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("h3", {
                                                        children: "No text categories found",
                                                        className: "text-lg font-medium text-gray-900"
                                                      }),
                                                  JsxRuntime.jsx("p", {
                                                        children: "Get started by creating your first text category",
                                                        className: "text-sm text-gray-500 mt-1"
                                                      })
                                                ]
                                              }),
                                          JsxRuntime.jsxs("button", {
                                                children: [
                                                  JsxRuntime.jsx("span", {
                                                        children: "+",
                                                        className: "mr-2"
                                                      }),
                                                  "Add Your First Category"
                                                ],
                                                className: "inline-flex items-center px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                                onClick: (function (param) {
                                                    Curry._1(dispatch, {
                                                          TAG: "SetFormAction",
                                                          _0: "Create"
                                                        });
                                                    Curry._1(dispatch, "ToggleTextCategoryModal");
                                                  })
                                              })
                                        ],
                                        className: "flex flex-col items-center space-y-4"
                                      }),
                                  className: "text-center py-12"
                                }),
                          className: "overflow-x-auto"
                        })
                  ],
                  className: "bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
                }),
            tmp$2
          ],
          className: "max-w-7xl mx-auto px-6 sm:px-8 py-8"
        });
  }
  return JsxRuntime.jsx("div", {
              children: tmp,
              className: "h-full bg-gray-50"
            });
}

var make = TextCategories;

exports.initialState = initialState;
exports.reducer = reducer;
exports.totalRecord = totalRecord;
exports.perPage = perPage;
exports.emptyPageInfo = emptyPageInfo;
exports.searchPlaceholder = searchPlaceholder;
exports.make = make;
/* initialState Not a pure module */
